<template>
  <div class="ins-s-sf" style="min-height: 680px;min-width: 1200px;">
    <div class="ins-login-content"  :style="{background: '#0079fe url(' + require('../../assets/image/login_bg.png') + ' )  no-repeat center'}">
    <!-- <div class="ins-login-content"> -->
        <div class="ins-content-right">
            <!-- 待修改 -->
            <div class="">
                <div style="padding: 0 60px">
                    <div class="ins-login-title text-center">
                      <img src="../../assets/image/logo.png" width='100px' alt="">
                      <div class='logo-title primary-color font-weight text-center'>欣宏钻石系统</div>
                      <div class='logo-title-small primary-color text-center'>XHXH&nbsp;System</div>
                    </div>
                    <!-- 账号密码登录 -->
                    <div>
                      <div class="ins-login-input">
                          <!-- 账号密码登录 -->
                          <div class="ins-login-pc">
                              <div  class="ins-lp-name" style="">
                                  <label class='ins-l-input-label' :class="{'dn':isFocusName}">用户名</label>
                                  <input @keyup="keyup($event,'password')" @focus = 'userLoginName' @blur="loginNameBlur" :class="{'focus':isFocusName}" autocomplete="off" class="formData-control" id="username" name="loginName" v-if='isFocusName' size="25" style="height:40px;box-sizing:border-box !important;width:100%;" tabindex="1" type="text" v-model="formData.userLoginName" value/>
                                  <input @keyup="keyup($event,'password')" @focus = 'userLoginName' @blur="loginNameBlur" :class="{'focus':isFocusName}" autocomplete="off" class="formData-control" id="username" name="loginName" v-if='!isFocusName' placeholder="输入用户名" size="25" style="height:40px;box-sizing:border-box !important;width:100%;" tabindex="1" type="text" v-model="formData.userLoginName" value/>
                              </div>
                              <div class="ins-lp-pwd" style="">
                                  <label class='ins-l-input-label' :class="{'dn':isFocusPwd}">输入密码</label>
                                  <input @keyup="keyup($event)" @focus = 'userMd5Password' @blur="loginPwdBlur" :class="{'focus':isFocusPwd}" autocomplete="off" class="form-control password" id="password" name="userMd5Password" v-if='isFocusPwd' size="25" style="height:40px;box-sizing:border-box !important;width:100%;" tabindex="2" type="password" v-model="formData.userMd5Password" value/>
                                  <input @keyup="keyup($event)" @focus = 'userMd5Password' @blur="loginPwdBlur" :class="{'focus':isFocusPwd}" autocomplete="off" class="form-control password" id="password" name="userMd5Password" v-if='!isFocusPwd' placeholder="输入密码" size="25" style="height:40px;box-sizing:border-box !important;width:100%;" tabindex="2" type="password" v-model="formData.userMd5Password" value/>
                              </div>
                              <button @click="submit" class="thlbottom thlbottom1">登录</button>
                          </div>
                      </div>
                    </div>
                </div>
            </div>
        </div>
        <div class='index-bottom'>
          <div>Copyright 2020 www.xhxh1993.com All Rights Reserved. 粤ICP备15117556号-1</div>
          <div>由TS科技提供技术支持</div>
        </div>
    </div>
</div>
</template>
<script>
export default {
  data () {
    return {
      fullscreenLoading: false,
      isFocusName: false,
      isFocusPwd: false,
      formData: { // 表单数据
        userLoginName: '',
        userMd5Password: ''
      }
    }
  },
  mounted () {
  },
  methods: {
    submit () {
      if (this.formData.userLoginName === '') {
        this.$message.warning('用户名不能为空')
        return
      }
      if (this.formData.userMd5Password === '') {
        this.$message.warning('密码不能为空')
        return
      }
      // md5加密
      let that = this
      this.YS.YS_md5().then(function (md5) {
        let sendData = Object.assign({}, that.formData)
        sendData.userMd5Password = md5.default(sendData.userMd5Password + '' + sendData.userMd5Password).toUpperCase()

        that.$ajax({ method: 'POST', url: 'auth/login', data: sendData })
        .then(res => {
          if (res.data.code === 1) {
            let userInfo = {
              userLoginName: res.data.data.userLoginName,
              userId: res.data.data.userId,
              userStatus:res.data.data.userStatus,
              userType:res.data.data.userType
            }
            let menu = []
            if(res.data.data.userType === 1){
              menu = [
                { menuId: 1, menuTitle: '货品管理', menuResUrl: '/goods' },
                { menuId: 2, menuTitle: '分类管理', menuResUrl: '/classify' },
                { menuId: 3, menuTitle: '员工管理', menuResUrl: '/staff' },
                { menuId: 4, menuTitle: '用户管理', menuResUrl: '/user' },
                { menuId: 6, menuTitle: '系统设置', menuResUrl: '/bannerManage' }
                // { menuId: 5, menuTitle: '系统管理', menuResUrl: '/setting' }
              ]
            }else if(res.data.data.userType === 2){
              menu = [
                { menuId: 1, menuTitle: '货品管理', menuResUrl: '/goods' },
                { menuId: 2, menuTitle: '分类管理', menuResUrl: '/classify' },
              ]
            }
            localStorage.setItem('userInfo', JSON.stringify(userInfo))
            localStorage.setItem('user_token', res.data.token) // 存储token
            localStorage.setItem('allMenu', JSON.stringify(menu))
            that.$router.replace({ path: '/goods' }) // 跳转到首页
          } else {
            that.$message.warning(res.data.desc)
          }
        })
        .catch(err => {
          console.log(err)
        })
      })
    },
    userLoginName () {
      this.isFocusName = !this.isFocusName
    },
    userMd5Password () {
      this.isFocusPwd = !this.isFocusPwd
    },
    loginNameBlur () {
      this.isFocusName = false
    },
    loginPwdBlur () {
      this.isFocusPwd = false
    },
    keyup (ev, id) {
      if (ev.keyCode === 13) {
        if (id) {
          document.querySelector('#' + id).focus()
        } else {
          this.submit()
        }
      }
    }
  }
}
</script>
<style scoped>
  .ins-login-content {
  width: 100%;
  height: 100vh;
  background: no-repeat 0px 0px;
  background-size: cover;
  background-repeat: no-repeat;
  overflow-x: hidden;
  position: relative;
}
.ins-login-content .ins-content-left {
  float: left;
  width: 70%;
  height: 100%;
  text-align: center;
}
.ins-content-left > img {
  position: relative;
  left: 0;
  top: 25%;
}
.ins-login-content .ins-content-right {
  position: absolute;
  background: #fff;
  transition: right 0.8s;
  -moz-transition: right 0.8s;
  -webkit-transition: right 0.8s;
  -o-transition: right 0.8s;
  width: 440px;
  height: 510px;
  top: 50%;
  left: 50%;
  margin-top: -255px;
  margin-left: -220px;
  border-radius: 20px;
}
.ins-login-pc input[placeholder] {
  font-weight: bold;
}
.ins-login-pc input {
  border: none;
  outline: none;
  border-bottom: 1px solid #ebebeb;
  font-weight: 0;
}
.ins-lp-pwd {
  margin-top: 30px;
}
.thlbottom {
  background: #007ef3;
  color: #fff;
  width: 100%;
  border-radius: 4px;
  border: none;
  position: relative;
  font-size: 16px;
  height: 45px;
  margin-top: 35px;
  font-weight: bold;
  cursor: pointer;
}

.thloginline {
  width: 200px;
  margin: 0 auto;
  height: 1px;
  border-top: 1px #858585 solid;
  position: relative;
  color: #858585;
}

.thloginline p {
  color: #858585;
  font-size: 13px;
  font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB,
    Microsoft YaHei, SimSun, sans-serif;
  padding: 0px 10px;
  background: #fff;
  position: absolute;
  top: -12px;
  left: 50px;
  cursor: pointer;
}

.h3 {
  margin-bottom: 25px;
}
.ins-login-title {
  position: relative;
  margin-top: 30px;
  margin-bottom: 25px;
}
.ins-login-txt {
  color: #1f264a;
  font-size: 30px;
  font-weight: 900;
}
.ins-register-txt {
  position: absolute;
  font-size: 18px;
  color: #fba40d;
  right: 0;
  top: 12px;
  font-weight: bold;
  cursor: pointer;
}
.ins-pc-forgetPwd {
  text-align: right;
  margin: 25px 0 0;
}
.ins-pc-forgetPwd .ins-pf {
  color: #007ef3;
  font-weight: bold;
}
.ins-lp-name,
.ins-lp-code,
.ins-lp-pwd {
    position: relative;
    height: 42px;
}
.ins-lp-code,
.ins-lp-pwd {
    margin-top: 30px;
}
.ins-l-input-label {
  display: none;
  font-size: 14px;
  color: #007ef3;
  font-weight: bold;
}

.ins-login-pc input.focus {
  border-bottom: 2px solid #007ef3;
}
.ins-login-pc .dn {
  display: block;
}

.qrcode-title {
  cursor: pointer;
  position: absolute;
  width: 45px;
  height: 115px;
  background: #fff;
  text-align: center;
  padding: 10px 0;
  left: -60px;
  bottom: 15px;
}

.ins-lp-code-btn {
  position: absolute;
  background: none;
  border: none;
  right: 0;
  top: 12px;
  font-weight: bold;
  color: #007ef3;
  outline: none;
  cursor: pointer;
}

button.ins-lp-code-btn:before {
  content: '';
  position: absolute;
  width: 1px;
  height: 12px;
  background: #007ef3;
  top: 6px;
  left: -5px;
}
.login-logo{
  position: absolute;
  left:100px;
  top:30px;
}
.logo-title{
  font-size:24px;
  margin: 16px 0 10px;
}
.logo-title-small{
  font-size:20px;
  margin-bottom:40px;
}
.index-bottom{
  position: absolute;
  width: 100%;
  text-align: center;
  color: rgba(193, 193, 193, 0.7098039215686275);
  bottom: 20px;
}
.index-bottom > div:last-child{
  margin-top:10px;
}
</style>


